import { Button, Col, Form, InputNumber, message, Row, Descriptions, Input } from 'antd';
import { errorMessage } from '../../utils/commonStringsConsts';
import { useState } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { request } from '../../../../shared/src/apis';
import { createAdvancePaymentRefund } from '../../utils/apisConsts';
import { stepperMoving } from '../../stores/actions';
export default function SubmitRefundExcess() {
    const [loader, setLoader] = useState(false);
    const userInfo = useSelector((state: any) => state?.actionsReducer?.info);
    const dispatch = useDispatch();
    const descriptionItems = [
        { label: "User ID", value: userInfo?.user?.userID ?? "N/A" },
        { label: "User name", value: userInfo?.user?.name ?? "N/A" },
        { label: "Email", value: userInfo?.user?.email ?? "N/A" },
        { label: "Phone", value: userInfo?.user?.phone ?? "N/A" },
        { label: "Net Salary", value: userInfo?.user?.netSalary ?? "N/A" },
        { label: "advance Payments Total", value: userInfo?.advancePaymentsTotal ?? "N/A" },
    ]
    const submitForm = async (values: any) => {
        setLoader(true);
        const { refundExcess, comment } = values;
        const payloadData = {
            phone: userInfo?.user?.phone,
            amount: refundExcess,
            comment: comment
        }
        console.log("payloadData", payloadData);
        try {
            const apiData: any = await dispatch(request({ method: 'POST', url: createAdvancePaymentRefund, data: payloadData }))
            const res = await apiData?.data;
            if (res?.status === 201 || res?.status === 200) {
                message.success(res?.message, 5);
                dispatch(stepperMoving(0));
                return
            }
            message.error(res?.message, 5);
        } catch (error) {
            message.error(errorMessage, 5);
        }
        setLoader(false);

    }
    return (
        <>
            <Descriptions bordered className="py-2.5">
                {descriptionItems?.map((item, index) => (
                    <Descriptions.Item key={index} span={3} label={item?.label} className="p-2.5">
                        {item?.value}
                    </Descriptions.Item>
                ))}
            </Descriptions>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <Form name="create" onFinish={submitForm} style={{ marginTop: '20px' }}>
                    <label>Refund Excess Amount <span>*</span></label>
                    <Form.Item>
                        <Row gutter={8}>
                            <Col flex="auto">
                                <Form.Item
                                    name="refundExcess"
                                    rules={[
                                        { required: true, message: 'Please enter the amount' },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (value > userInfo?.advancePaymentsTotal) {
                                                    return Promise.reject(new Error(`Amount cannot exceed ${userInfo?.advancePaymentsTotal}`));
                                                }
                                                if (value <= 0) {
                                                    return Promise.reject(new Error(`Amount should be bigger than 0`));
                                                }
                                                return Promise.resolve();
                                            },
                                        }),
                                    ]}
                                    style={{ marginBottom: '20px' }}
                                >
                                    <InputNumber style={{ width: '100%' }} placeholder='Please enter the amount' />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item>
                        <label>Comment <span>*</span></label>
                        <Row gutter={8}>
                            <Col flex="auto">
                                <Form.Item
                                    name="comment"
                                    style={{ marginBottom: '20px' }}
                                    rules={[{ required: true, message: 'Please enter your comment' }]}
                                >
                                    <Input.TextArea rows={5} style={{ width: '100%' }} placeholder='Please enter your comment' />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button type="primary" htmlType="submit" loading={loader}>
                                    Refund Excess
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </div>
        </>
    )
}

